module.exports = require("/tmp/build_615fc3e2/src/lib/gatsby/gatsby-browser.tsx");